import React from 'react';
import PropTypes from 'prop-types';
import { MoreNewsItem }
from '@fuww/library/src/Articles/Sections/MoreNews';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import CardWithLink from '../../../CardWithLink';
import articlesQuery from '../../../../lib/queries/news/articlesQuery.graphql';
import { featuredCategoryIds } from '../../../../lib/mainCategoryIds';
import { useSiteContext } from '../../../SiteContext';
import withQuery from '../../../../lib/withQuery';
import useNoCacheOnServerFetchPolicy
from '../../../../lib/useNoCacheOnServerFetchPolicy';
import {
  moreNewsCardImageConfigurations,
} from '../../../../lib/imageConfigurations';

const errorMessage = 'Error loading news articles...';

const MoreNewsCards = ({
  data, variables, showCreatedAt,
}) => {
  const newsArticles = data?.universalNewsArticles;
  return (
    newsArticles && (
      <>
        {
          newsArticles.map((article) => (
            <MoreNewsItem
              key={article.id}
              className="fu-read-more"
            >
              <CardWithLink
                newsArticle={article}
                variables={variables}
                sizes={`
                  (min-width: 1440px) 318px,
                  (min-width: ${breakpoints.lg}px) 23vw,
                  (min-width: ${breakpoints.sm}px) 47vw,
                  100vw
                `}
                showCreatedAt={showCreatedAt}
                withPageMargins
              />
              <SpacingContainer />
            </MoreNewsItem>
          ))
        }
      </>
    )
  );
};

MoreNewsCards.propTypes = {
  data: PropTypes.shape({
    universalNewsArticles: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  variables: PropTypes.shape({}).isRequired,
  showCreatedAt: PropTypes.bool,
};

MoreNewsCards.defaultProps = {
  showCreatedAt: false,
  data: 'null',
};

const MoreNewsCardBlockWithQuery = withQuery(MoreNewsCards);

const MoreNewsCardBlock = ({
  notInIds, showCreatedAt, offset, skip,
}) => {
  const { newsboard } = useSiteContext();
  const fetchPolicy = useNoCacheOnServerFetchPolicy();

  return (
    <MoreNewsCardBlockWithQuery
      query={articlesQuery}
      showCreatedAt={showCreatedAt}
      variables={{
        newsboard,
        withoutSummaryAndLabel: false,
        withoutDescriptionAndCreator: false,
        offset,
        limit: 4,
        sort: 'CREATED_AT',
        statuses: ['PUBLISHED'],
        categoryIds: featuredCategoryIds,
        imageConfigurations: moreNewsCardImageConfigurations,
        notInIds,
      }}
      errorMessage={errorMessage}
      fetchPolicy={fetchPolicy}
      skip={skip}
    />
  );
};

MoreNewsCardBlock.cardinality = 4;

MoreNewsCardBlock.propTypes = {
  notInIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  showCreatedAt: PropTypes.bool,
  offset: PropTypes.number,
  skip: PropTypes.bool,
};

MoreNewsCardBlock.defaultProps = {
  showCreatedAt: false,
  offset: 0,
  skip: false,
};

export default MoreNewsCardBlock;
